module.exports = __webpack_public_path__ + "static/media/PositiveSelfAffirmations.fc3003fb.jpg";